var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2A6DF571-CE17-41E9-81A4-198E729372CB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rebates",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lincolnrebates_redeemrebates_step2_Desktop",
    transform: "translate(-205.000000, -2640.000000)",
    fill: "#F26147",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lincoln_Redeem_Step2_desktop",
    transform: "translate(0.000000, 1269.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plus",
    transform: "translate(205.000000, 1371.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M12,1.6 C6.2562386,1.6 1.6,6.2562386 1.6,12 C1.6,17.7437614 6.2562386,22.4 12,22.4 C17.7437614,22.4 22.4,17.7437614 22.4,12 C22.4,6.2562386 17.7437614,1.6 12,1.6 Z M12.99996,6 L12.99996,11.1 L18,11.1 L18,12.99996 L12.99996,12.99996 L12.99996,17.4 L11.1,17.4 L11.1,12.99996 L6,12.99996 L6,11.1 L11.1,11.1 L11.1,6 L12.99996,6 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.5f4bf1be1eab006adcb420e856c46acb.svg";
export { ForwardRef as ReactComponent };